import config from "@/config";
import { AppPlatform } from "@/constants";

export const generateImageUrl = ({
	imageId,
	width,
	height,
	reason,
	rotate,
}) => {
	let testImageApi = false;

	if (typeof window !== "undefined") {
		const requestQuery = new URLSearchParams(window.location.search);
		testImageApi = requestQuery.get("test") === "true";
	}

	const urlSearchParams = new URLSearchParams();
	urlSearchParams.append("width", width);
	urlSearchParams.append("height", height);
	urlSearchParams.append("reason", reason);
	urlSearchParams.append("auto_rotate", rotate);
	// urlSearchParams.append('reflected_distinct_id', mixpanel.get_distinct_id());
	urlSearchParams.append(
		"app_platform",
		reason.startsWith("topten") || reason.startsWith("top_ten")
			? AppPlatform.TT
			: AppPlatform.LP
	);
	urlSearchParams.append("app_version", config.version.path);
	// urlSearchParams.append('quality', '10');

	const path = testImageApi ? "imagedashboard2" : "imagedashboard";

	if (!imageId) {
		return `${config.api.address
			}/${path}/MAP_IMG_DEFAULT_4?${urlSearchParams.toString()}`;
	}

	return `${config.api.address
		}/${path}/${imageId}?${urlSearchParams.toString()}`;
};

export const formatAmount = (amount) => {
	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		compactDisplay: "short",
		maximumFractionDigits: 0,
	})
		.format(amount)
		.toLowerCase();
};

export const derivePossessiveForm = (name) => {
	if (!name) return "";
	const lastLetter = name[name.length - 1];
	return lastLetter === "s" ? `${name}'` : `${name}'s`;
};
export const FormatAmount = (amount) => {
	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		compactDisplay: "short",
		maximumFractionDigits: 0,
	})
		.format(amount)
		.toLowerCase();
};

export const upperFirst = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
